import { DialogElement } from 'theme';

class CustomPopup extends DialogElement {
  connectedCallback() {
    super.connectedCallback();

    if (!Shopify.designMode && this.shouldAppearAutomatically) {
      this.#initScrollTrigger();
    }

    const overlay = this.querySelector('.modal-overlay');
    overlay?.addEventListener('click', (event) => {
      if (event.target === overlay) {
        this.hide();
      }
    });
  }

  get initialFocus() {
    return false;
  }

  get shouldAppendToBody() {
    return true;
  }

  get shouldLock() {
    return true;
  }

  get config() {
    try {
      return JSON.parse(this.dataset.config);
    } catch {
      return {};
    }
  }

  get scrollTrigger() {
    return parseInt(this.config.scrollTrigger) || 30;
  }

  get reappearAfter() {
    return parseFloat(this.config.reappearAfter) || 7;
  }

  get storageKey() {
    return 'theme:custom-popup-shown:' + this.id;
  }

  get shouldAppearAutomatically() {
    const stored = localStorage.getItem(this.storageKey);
    if (stored) {
      try {
        const { expires } = JSON.parse(stored);
        if (expires && Date.now() < expires) {
          return false;
        }
      } catch {
        localStorage.removeItem(this.storageKey);
      }
    }

    return true;
  }

  #initScrollTrigger() {
    const threshold = this.scrollTrigger;

    const onScroll = () => {
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (docHeight <= 0) return;

      const scrollPercent = (window.scrollY / docHeight) * 100;
      if (scrollPercent >= threshold) {
        window.removeEventListener('scroll', onScroll);
        this.show();
      }
    };

    window.addEventListener('scroll', onScroll);
    onScroll();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    super.attributeChangedCallback(name, oldValue, newValue);

    if (name === 'open' && this.open) {
      const days = this.reappearAfter;
      const expires = Date.now() + days * 24 * 60 * 60 * 1000;
      localStorage.setItem(this.storageKey, JSON.stringify({ opened: true, expires }));
    }
  }
}

customElements.define('custom-popup', CustomPopup);
